export default {
  PRIVACY_LINK: 'https://www.mono.site/cookie-og-privatlivspolitik',
  CONDITIONS_LINK: 'https://www.mono.site/forretningsbetingelser'
}
